export enum HilbiWidgetViews {
  Search = 0,
  InstitutionExpertise = 1,
  AppointmentDate = 2,
  OrderRecap = 3,
  CheckEmail= 4,
  ConfirmEmail = 5,
  UserData = 6,
  Last = 7
}
